
import { Suspense } from 'react';
import { Redirect, Route, Router, Switch } from "react-router-dom";
import { PrivateRoute } from '../components/private-route';
import { history } from '../_helpers';
import routes, { privateRoutes } from './routes';
import SFooter from './SFooter';
import SHeader from './SHeader';
import SLogin from './SLogin';

const loading = <h3>Loading...</h3>;

const SLayout = (props: any) => {
  return (
    <Router history={history}>
      <section>
        <SHeader />
        <div className="container-top d-none d-sm-block"></div>
        {/* A <Switch> looks through its children <Route>s and
                renders the first one that matches the current URL. */}
        <Suspense fallback={loading}>
          <Switch>
            {routes.map(({ path, component }, key) => {
              return <Route exact key={key} path={path} component={component} />
            })}
            {privateRoutes.map(({ path, component, showLogin }, key) => {
              return <PrivateRoute exact key={key} path={path} component={component} showLogin={showLogin} />
            })}
            <Redirect to="/" />
          </Switch>
        </Suspense>
        <SLogin />
        <SFooter />
      </section>
    </Router>
  )
};


export default SLayout;
